import { NormalizedNumber, Percentage } from '@sparkdotfi/common-universal'
import BigNumber from 'bignumber.js'

import { stusdsWithdrawDataQueryFunction } from './stusdsWithdrawDataQuery'
import { SavingsConverter } from '@/features/savings/logic/savings-converters/types'
import { EPOCH_LENGTH } from '@/features/sparklend/common/data/market-info/consts'
import { pow } from '@/utils/math'

export interface CalculateStusdsLiquidityBufferedParams {
  converter: SavingsConverter
  stusdsData: Awaited<ReturnType<typeof stusdsWithdrawDataQueryFunction>>
  timestamp: number
}

export function calculateStusdsLiquidityBuffered({
  converter,
  stusdsData,
}: CalculateStusdsLiquidityBufferedParams): NormalizedNumber {
  const totalAssets = stusdsData.totalAssets

  const totalAssetsIn1Epoch = converter
    .predictAssetsAmount({
      shares: stusdsData.totalSupply,
      timestamp: converter.currentTimestamp + EPOCH_LENGTH,
    })
    .decimalPlaces(18, BigNumber.ROUND_UP)

  const totalDebt = stusdsData.lockstakeDebt
  const totalDebtIn1Epoch = stusdsData.lockstakeDebt
    .times(Percentage(pow(stusdsData.lockstakeDebtRate.toBigNumber(), EPOCH_LENGTH), { allowMoreThan1: true }))
    .decimalPlaces(18, BigNumber.ROUND_UP)

  const liquidity = totalAssets.minus(totalDebt)
  const liquidityIn1Epoch = totalAssetsIn1Epoch.minus(totalDebtIn1Epoch)
  const liquidityBuffered = NormalizedNumber.min(liquidity, liquidityIn1Epoch)

  return NormalizedNumber.max(liquidityBuffered, NormalizedNumber.ZERO)
}
